module.exports = __webpack_public_path__ + "static/media/logo-grey.1d033414.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/assets/logos/logo-grey.svg
// module id = 1758
// module chunks = 0